export default "__VITE_ASSET__BvURG7lJ__"